import { connect } from 'react-redux';
import { sortBy } from 'lodash';
import BaseForm from '../BaseForm/BaseForm';
import {
  addVehicle,
  showError,
  clearErrors,
} from '../../redux/actions/vehicles';
import conditions from '../../data/conditions';
import insured from '../../data/insured';

class VehicleCreateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: addVehicle,
      name: 'Vehicle',
      action: 'Add',
      type: 'create',
      isTypeForm: true,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.registration)) {
      this.props.dispatch(showError('Please specify a name'));
      return false;
    }
    if (isIndex(1) && !BaseForm.validator.isNumeric(data.vehicle_type_id)) {
      this.props.dispatch(showError('Please specify the vehicle type'));
      return false;
    }
    if (isIndex(2) && BaseForm.validator.isEmpty(data.manufacture_date)) {
      this.props.dispatch(showError('Please specify the manufacture date'));
      return false;
    }
    if (isIndex(3) && !BaseForm.validator.isNumeric(data.mileage)) {
      this.props.dispatch(showError('Please specify the mileage'));
      return false;
    }
    if (isIndex(4) && !BaseForm.validator.isNumeric(data.service_mileage)) {
      this.props.dispatch(showError('Please specify the service mileage'));
      return false;
    }
    if (isIndex(5) && BaseForm.validator.isEmpty(data.mot_date)) {
      this.props.dispatch(showError('Please specify the MOT date'));
      return false;
    }
    if (isIndex(6) && !BaseForm.validator.isNumeric(data.condition)) {
      this.props.dispatch(showError('Please specify the vehicle condition'));
      return false;
    }
    if (isIndex(7) && !BaseForm.validator.isNumeric(data.insured)) {
      this.props.dispatch(
        showError('Please specify whether the vehicle is insured or not'),
      );
      return false;
    }
    return data;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    dispatch(actions.change('create.registration', ''));
    dispatch(actions.change('create.vehicle_type_id', ''));
    dispatch(actions.change('create.manufacture_date', ''));
    dispatch(actions.change('create.mileage', ''));
    dispatch(actions.change('create.service_mileage', ''));
    dispatch(actions.change('create.mot_date', ''));
    dispatch(actions.change('create.condition', ''));
    dispatch(actions.change('create.insured', ''));
  }
}

const mapStateToProps = ({ vehicles, vehicleTypes }) => ({
  model: vehicles,
  fields: BaseForm.fields.vehicles.create,
  values: {
    insured,
    vehicle_type_id: sortBy(vehicleTypes.vehicleTypes, ['size', 'id']).map(
      (type) => ({
        name: type.name,
        value: type.id,
      }),
    ),
    condition: conditions,
  },
});

export default connect(mapStateToProps)(VehicleCreateForm);
